import { render, staticRenderFns } from "./RevisingEditorSaveActions.vue?vue&type=template&id=2c0c2ffd&scoped=true"
import script from "./RevisingEditorSaveActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./RevisingEditorSaveActions.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RevisingEditorSaveActions.vue?vue&type=style&index=0&id=2c0c2ffd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c2ffd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0c2ffd')) {
      api.createRecord('2c0c2ffd', component.options)
    } else {
      api.reload('2c0c2ffd', component.options)
    }
    module.hot.accept("./RevisingEditorSaveActions.vue?vue&type=template&id=2c0c2ffd&scoped=true", function () {
      api.rerender('2c0c2ffd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/revising/RevisingEditorSaveActions.vue"
export default component.exports